import {postRequest} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";

import {IArticleCommentFormValues} from "../components/comments/ArticleCommentForm";

export const postArticleComment = (jsonData: Partial<IArticleCommentFormValues & {article: number}>) => {
    return postRequest({}, apiPath.comments.article.base, jsonData).then((result: IArticleCommentFormValues) => {
        return result;
    });
};
import {postRequest} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";

import {IArticleCommentFormValues} from "../components/comments/ArticleCommentForm";

export const postArticleComment = (jsonData: Partial<IArticleCommentFormValues & {article: number}>) => {
    return postRequest({}, apiPath.comments.article.base, jsonData).then((result: IArticleCommentFormValues) => {
        return result;
    });
};
